import { Box, Button, SvgIcon } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledWrapper = styled(Box)`
  width: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: center;

  background-color: #363846;
  border: 1px solid #ebebf7;
  color: #ffffff;

  &:first-of-type {
    border-radius: 8px 0 0 8px;
  }

  &:last-of-type {
    border-radius: 0 8px 8px 0;
  }

  &:hover {
    background-color: #363846;
    outline: 1px solid #fff;
    color: #ffffff;
  }
`;

export const StyledMuiButton = styled(Button)`
  width: 100%;
  padding: 4px 0;
`;

export const StyledMuiSvgIcon = styled(SvgIcon)`
  width: auto;
  min-height: 8px;
`;
